export default __webpack_public_path__ + "static/logo.min-c611840998cd40ca993392a8e3de4c43.svg";